<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Начисление виртуального кредита</h3>
        <button type="button" class="close" @click="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Количество кредита (сумма в формате целого числа, либо 100.5)</label>
          <input
            type="text"
            class="form-control"
            name="cost"
            v-validate="'required'"
            v-model="credit.cost"
            data-vv-as="Количество кредита (сумма в формате целого числа, либо 100.5)"
          >
        </div>
      </div>
      <div class="modal-footer d-flex">
        <btn-action
          class="btn btn-primary ml-auto"
          @click="save"
        >Выдать кредит</btn-action>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'

  export default {
    props: ['matrix', 'isCoffee', 'modemUid'],
    data () {
      return {
        selectedProduct: null,
        sugar: 0,
        cup: true,
        credit: {
            cost: "0.00",
        },
      }
    },
    methods: {
      save () {
        let data = {
          credit: this.credit.cost,
        //   product_id: this.selectedProduct.id,
        }
        // if (this.isCoffee) {
        //   data = Object.assign(data, {
        //     sugar: this.sugar,
        //     cup: this.cup,
        //   })
        // }
        console.log(this.credit.cost);
        console.log(data);
        return api.post(`modems/${this.modemUid}/commands/cashless?${this.credit.cost}`, data).then(() => this.hide())
      },
      hide () {
        this.$emit('hide')
      },
    },
    computed: {
      options () {
        return this.matrix ? this.matrix.products.map((el) => el.product) : []
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/machines/modals/cashless-modal.vue